module.exports = __webpack_public_path__ + "img/场景化(1)@2x.923c8085.png";